import MuiTooltip from '@mui/material/Tooltip';
import type { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

/** Alias direto do MUI: nenhum default de aparência do projeto diverge do componente. */
export type TooltipProps = MuiTooltipProps;

/**
 * Tooltip do design system: função simples, sem `forwardRef` — o próprio `Tooltip` do MUI não
 * aceita `ref` no elemento raiz (ele clona o único filho e encaminha a referência a ele), então
 * o wrapper não teria a quem repassar um `ref` próprio. Ver `AccountSelector`
 * (`layout/navbar/`) como uso de referência já existente.
 */
export function Tooltip(props: TooltipProps): JSX.Element {
  return <MuiTooltip {...props} />;
}
